export default class HeadquarterRepository {
  ofClient(clientId) {}

  delete(headquartersId) {}

  save(headquarter) {}

  retrieve(headquartersId) {}
}
